import City from 'componentsForThree/City';
import { Suspense, useContext, useEffect, useMemo, useState } from 'react';
import ExpandButton from 'componentsForThree/ExpandButton';
import { CitesType } from 'types/global';
import { mapSizeX, mapSizeY, initIndex } from 'constant/env';
import { ControlContext } from 'provider/ControlProvider';
import { useProgress, Html, Preload } from '@react-three/drei';

export default function Cities() {
  const { allCity } = useContext(ControlContext);
  const [data, setData] = useState<CitesType>({
    cities: [initIndex],
    expandBtns: [
      initIndex - 1,
      initIndex + 1,
      initIndex - mapSizeX,
      initIndex + mapSizeX,
    ],
  });
  const AllCities = useMemo(
    () =>
      Array(mapSizeX * mapSizeY)
        .fill(null)
        .map((_, i) => i),
    []
  );
  console.log('AllCities', AllCities);
  useEffect(() => {
    if (allCity)
      setData({
        cities: AllCities,
        expandBtns: [],
      });
    else
      setData({
        cities: [initIndex],
        expandBtns: [
          initIndex - 1,
          initIndex + 1,
          initIndex - mapSizeX,
          initIndex + mapSizeX,
        ],
      });
  }, [allCity]);
  const cities = useMemo(
    () => data.cities.map((col) => <City index={col} key={col} />),
    [data.cities]
  );

  const expandBtns = useMemo(
    () =>
      data.expandBtns.map((btn) => (
        <ExpandButton index={btn} setData={setData} data={data} key={btn} />
      )),
    [data.expandBtns]
  );
  return (
    <Suspense fallback={allCity ? <Loader /> : null}>
      <group name='cities'>{cities}</group>
      <group name='expandButtons'>{expandBtns}</group>
      <Preload all />
    </Suspense>
  );
}
function Loader() {
  const { progress } = useProgress();
  return (
    <Html center className='absolute z-50 bg-black text-white'>
      {progress} % loaded
    </Html>
  );
}
